// extracted by mini-css-extract-plugin
export default {"card":"Card_card__8ScBJ","head":"Card_head__Pz+ve","action":"Card_action__ANdrq","body":"Card_body__qTGFE"};